import * as array from 'd3-array'
import * as scale from 'd3-scale'
import container from './container'
import {dimensions} from './container'
import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import basicAnimation from './animations/basic-animation'
import * as colors from 'colors'

// These will eventually be customizable
const rows = 10
    , columns = 10

export const animations = [
  basicAnimation
]

/*
 * Determines the aspect ratio of the grid. See https://github.com/SpiderStrategies/Scoreboard/issues/37538
 * for rules. If we're showing just a chart without descriptions, we
 * use a 1:1 grid. Otherwise we use 9:16 grid
 */
const aspectRatio = series => {
  if (series.length === 1 && series[0].subtitle) {
    // Single series shown with a description, use 9:16
    return 9 / 16
  } else {
    return 1
  }
}

/*
 * Build the stack of thresholds based on the points in this waffle chart
 */
const getThresholdScale = (points, total) => {
  let domain = points.map(p => p._range[1]) // Domain of top values
    , range = points.map(p => p)

  // The series
  if (domain[domain.length -1] < total) {
    domain.push(total)

    range.push({
      color: 'empty-pocket'
    })
  }

  let linear = scale.scaleLinear()
                    .domain([0, rows * columns - 1])
                    .range([0, domain[domain.length - 1]])
    , threshold = scale.scaleThreshold()
                       .domain(domain)
                       .range(range)

  return pocket => {
    return threshold(linear(pocket))
  }
}

/*
 * Determines how much height we need to draw the labels
 */
const getMetaHeight = (series, grid, axes) => {
  let height = 0

  if ((series.length == 1 && (series[0].title || axes.infographic.totalLabel)) || grid.length > 1) {
    height += dimensions.titleOffset
  }

  if (series.length === 1 && series.some(s => s.subtitle) && grid.length == 1) {
    // Showing the description field
    height += dimensions.subtitleHeight
  }

  return height
}

export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , dimensions = chart.datum().dimensions
    , axes = chart.datum().axes
    , grid = chart.layout.getGrid(dimensions, aspectRatio(seriesData))
    , metaHeight = getMetaHeight(seriesData, grid.blocks, axes)
    , rowScale = scale.scaleBand().domain(array.range(rows).reverse()).range([0, grid.height - metaHeight]).padding(.1)
    , columnScale = scale.scaleBand().domain(array.range(columns)).range([0, grid.width]).padding(.1)
    , serieColors = new Set

  serieColors.add('empty-pocket')

  // There's a waffle chart in each block
  let waffles = grid.blocks.map(block => {
    // Grab the the point for each series
    let points = seriesData.map(serie => {
        let point = util.getPoint(block.range.id, serie)
        point.formatted = (serie.formatter || (d => d))(point.raw)
        serieColors.add(point.color)
        return point
      })
      , pointsTotal = array.sum(points, p => p.raw)
      , total = util.total(axes, pointsTotal) // Total for this waffle

    // Build a threshold scale we'll use to color the blocks
    let threshold = getThresholdScale(points, total)
      , pockets = array.range(rows * columns)

    return {
      title: util.title(grid.blocks, block, seriesData),
      subtitle: (seriesData.length === 1  && grid.blocks.length == 1 )? seriesData[0].subtitle : null,
      totalLabel: seriesData.length == 1 && axes.infographic.totalLabel, // Boolean if we show the total
      block,
      pockets,
      threshold,
      points
    }
  })

   d3.select(selection.node().ownerSVGElement).select('defs')
     .call(util.coloredGradients, 'waffle', Array.from(serieColors), [0, .5, 1], chart.defaultTransition)
     .selectAll('linearGradient')
     .each(function (color) {
       if (color == 'empty-pocket') {
        return // This is handled in css
       }
       d3.select(this)
         .selectAll('stop')
         .attr('stop-color', (d, idx) => {
           switch (idx) {
             case 0:
               return colors.adjustLightness(colors.lookup(color), 20)
             case 1:
               return colors.lookup(color)
             case 2:
               return colors.adjustLightness(colors.lookup(color), -15)
           }
         })
     })

  selection.call(container, chart, waffles, columns, rows, columnScale, rowScale)
}
